import api from '../index'

export default {

    /**
     * Show a billing account
     * @param billingAccount
     * @param params
     */
    show(billingAccount, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create a billing account
     * @param data
     */
    create(data) {
        return api
            .post(`/billing/billing-accounts`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Update a billing account
     * @param billingAccount
     * @param data
     */
    update(billingAccount, data) {
        return api
            .put(`/billing/billing-accounts/${billingAccount}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete a billing account
     * @param billingAccount
     */
    delete(billingAccount) {
        return api
            .delete(`/billing/billing-accounts/${billingAccount}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get invoices of a billing account
     * @param billingAccount
     * @param params
     */
    getInvoices(billingAccount, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/invoices`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get products of a billing account
     * @param billingAccount
     * @param params
     */
    getProducts(billingAccount, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/products`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create quote
     * @param billingAccount
     * @param data
     */
    createQuote(billingAccount, data) {
        return api
            .post(`/billing/billing-accounts/${billingAccount}/quotes`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get quotes of a billing account
     * @param billingAccount
     * @param params
     */
    getQuotes(billingAccount, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/quotes`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get payment methods
     * @param billingAccount
     * @param params
     */
    getPaymentMethods(billingAccount, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/payment-methods`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create payment method
     * @param billingAccount
     * @param data
     */
    createPaymentMethod(billingAccount, data) {
        return api
            .post(`/billing/billing-accounts/${billingAccount}/payment-methods`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete payment method
     * @param billingAccount
     * @param paymentMethod
     * @param params
     */
    deletePaymentMethod(billingAccount, paymentMethod, params) {
        return api
            .delete(`/billing/billing-accounts/${billingAccount}/payment-methods/${paymentMethod}`)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get payment method
     * @param billingAccount
     * @param paymentMethod
     * @param params
     */
    getPaymentMethod(billingAccount, paymentMethod, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/payment-methods/${paymentMethod}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get pending quote lines
     * @param billingAccount
     * @param params
     */
    getPendingQuoteLines(billingAccount, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/pending-quote-lines`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Get credit notes
     * @param billingAccount
     * @param params
     */
    getCreditNotes(billingAccount, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/credit-notes`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    }

}
